import React, { useCallback } from "react";

import { useIntl } from "react-intl";

import { showModal } from "@mapmycustomers/ui";

import { LabeledSwitch } from "@app/component/input/LabeledSwitch";

interface Props {
  onChange?: (value: boolean) => void;
  value?: boolean;
}

const ActiveCheckIn: React.FC<Props> = ({ onChange, value }) => {
  const intl = useIntl();

  const handleChange = useCallback(
    (checked: boolean) => {
      showModal({
        content: intl.formatMessage({
          id: "settings.organizationDetails.activities.activeCheckIn.warning.description",
          defaultMessage:
            "Reps will encounter disruptions in check-ins that they are completing right now. Consider changing this setting outside regular work hours to minimize issues.",
          description:
            "Settings organization details - Activities - Active Check-Ins - warning description",
        }),
        okText: intl.formatMessage({
          id: "settings.organizationDetails.activities.activeCheckIn.warning.continue",
          defaultMessage: "Continue",
          description:
            "Settings organization details - Activities - Active Check-Ins - warning continue",
        }),
        onOk: () => onChange?.(checked),
        title: intl.formatMessage({
          id: "settings.organizationDetails.activities.activeCheckIn.warning.title",
          defaultMessage:
            "Altering this setting will disrupt check-ins that are being completed right now",
          description:
            "Settings organization details - Activities - Active Check-Ins - warning title",
        }),
        type: "confirm",
      });
    },
    [intl, onChange]
  );

  return (
    <LabeledSwitch
      checked={value}
      description={intl.formatMessage({
        id: "settings.organizationDetails.activities.activeCheckIn.switch.description",
        defaultMessage:
          "Enable this setting to have reps check-in upon arrival and check-out when they're ready to take notes, accurately measuring their stop durations. When disabled, reps only check-in once when they're ready to jot down notes. We recommend enabling this setting as two-step check-ins historically follow a rep’s typical workflow.",
        description: "Settings organization details - Activities - Active Check-Ins - description",
      })}
      onChange={handleChange}
      title={intl.formatMessage({
        id: "settings.organizationDetails.activities.activeCheckIn.switch.title",
        defaultMessage: "Two-step Check-ins",
        description: "Settings organization details - Activities - Active Check-Ins - title",
      })}
    />
  );
};

export default ActiveCheckIn;
